import React from 'react';
import { Spinner } from './Loading.styles';

export const Loading = () => {
  return (
    <div>
      <Spinner />
    </div>
  );
};
